import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import useUserStore from '../store/useUserStore'
import { removeLocalStorage } from '../utils/common'

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const userInfo = useUserStore((state) => state.userInfo)

  const isInAppBrowser = (): boolean => {
    const userAgent: string =
      navigator.userAgent ||
      navigator.vendor ||
      (window as Window & { opera?: string }).opera ||
      ''

    return /FBAN|FBAV|Instagram|Line|KAKAOTALK|NAVER|TikTok/i.test(userAgent)
  }

  useEffect(() => {
    if (isMobile) {
      const isInApp = isInAppBrowser()
      if (isInApp) {
        const url = window.location.href
        const userAgent: string =
          navigator.userAgent ||
          navigator.vendor ||
          (window as Window & { opera?: string }).opera ||
          ''
        if (/android/i.test(userAgent)) {
          const intentUrl = `intent://${url.replace(
            /^https?:\/\//,
            ''
          )}#Intent;scheme=https;package=com.android.chrome;end;`
          window.location.href = intentUrl
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
          window.location.href =
            'kakaotalk://web/openExternal?url=' + encodeURIComponent(url)
        }
      }
    }
  }, [])

  useEffect(() => {
    if (userInfo && !userInfo?.affiliate?.point) {
      removeLocalStorage('affiliate_source')
      removeLocalStorage('affiliate_campaign')
    }

    if (window.ChannelIO && userInfo) {
      window.ChannelIO('boot', {
        pluginKey: process.env.REACT_APP_CHANNEL_TALK_KEY,
        memberId: userInfo.userInfo?.id ?? 0,
        profile: {
          name: userInfo.userInfo?.name,
          email: userInfo.userInfo?.email,
        },
      })
    } else if (window.ChannelIO && !userInfo) {
      window.ChannelIO('boot', {
        pluginKey: '56355af5-b4ef-4ef1-b558-a496ca3c9831',
      })
    }
  }, [userInfo])

  return <>{children}</>
}